import templateStr from 'text!./templates/yes-no.html';

export default [function () {
    return {
        restrict: 'AE',
        template: templateStr,
        scope: {
            model: '='
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/YesNo.js
// module id = 781
// module chunks = 0